import "./assets/style/css/tailwind.css";
import "./assets/style/sass/main.scss";
import "./assets/style/sass/mixin.scss";

// console.log("install.js");
// console.log(process.env)
export default {
  install() {},
};
